import { labelOnly } from "../label-only";
import type { ToolActivity } from "../tool-activity";
import { toolInput } from "../tool-input";

export function describeReportDevServer(
  record: Record<string, unknown>,
): ToolActivity {
  const status = toolInput.str(record.status);
  const port = toolInput.str(record.port) ?? String(record.port ?? "");
  if (status && port) {
    return labelOnly(`Reported the dev server ${status} on port ${port}`);
  }
  if (status) {
    return labelOnly(`Reported the dev server ${status}`);
  }
  return labelOnly("Reported the dev server");
}
